// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"702":"7662dc23ed1c93108277","715":"34dd6ecb43cd754170af","805":"711e8e63401ae8a59a4a"}[chunkId] + ".css";
};